// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepAiOption__uwsla {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
}

.optionItem__UX4Lk {
  padding: 20px;
  background: var(--tables-secondary-row-sub-title-surface);
  border: 1px solid transparent;
  cursor: pointer;
}

.optionItemSelected__QUx2p {
  border: 1px solid var(--inputs-focus-stroke);
}
.optionItemSelected__QUx2p .optionItemTitle__uo_ny {
  font-weight: 700;
}

.optionItemTitle__uo_ny {
  color: var(--legend-for-header-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
}

.optionItemDescr__GbNct {
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-top: 10px;
}

.helperText__N9mNx {
  margin-top: 4px;
  color: var(--inputs-error-text-helper);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__N9mNx {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/AddActionItemModal/components/StepAIOption/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,8BAAA;EACA,gBAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,yDAAA;EACA,6BAAA;EACA,eAAA;AAzEF;;AA4EA;EACE,4CAAA;AAzEF;AA2EE;EACE,gBAAA;AAzEJ;;AA6EA;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA1EF;;AA6EA;EACE,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AA1EF;;AA6EA;EACE,eAAA;EACA,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;AA1EF;AA4EE;EAVF;IAWI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAzEF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.stepAiOption {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  column-gap: 20px;\n}\n\n.optionItem {\n  padding: 20px;\n  background: var(--tables-secondary-row-sub-title-surface);\n  border: 1px solid transparent;\n  cursor: pointer;\n}\n\n.optionItemSelected {\n  border: 1px solid var(--inputs-focus-stroke);\n\n  .optionItemTitle {\n    font-weight: 700;\n  }\n}\n\n.optionItemTitle {\n  color: var(--legend-for-header-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.optionItemDescr {\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 18px;\n  margin-top: 10px;\n}\n\n.helperText {\n  margin-top: 4px;\n  color: var(--inputs-error-text-helper);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepAiOption": `stepAiOption__uwsla`,
	"optionItem": `optionItem__UX4Lk`,
	"optionItemSelected": `optionItemSelected__QUx2p`,
	"optionItemTitle": `optionItemTitle__uo_ny`,
	"optionItemDescr": `optionItemDescr__GbNct`,
	"helperText": `helperText__N9mNx`
};
module.exports = ___CSS_LOADER_EXPORT___;
